import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Delete from '@material-ui/icons/Delete';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 200,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  pointer: {
    cursor: 'pointer'
  }
});

function RoomerPostList(props) {
  const { 
    classes, 
    list, 
    updatePost, 
    handleChangeRowsPerPage, 
    handleChangePage, 
    rowsPerPage, 
    page,
    totalRecords,
    openView,
    removePost
  } = props;
  return (
    <React.Fragment>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <CustomTableCell>Post By</CustomTableCell>
            <CustomTableCell>Description</CustomTableCell>
            <CustomTableCell>View</CustomTableCell>
            <CustomTableCell>Edit</CustomTableCell>
            <CustomTableCell>Delete</CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map(row => {
            return (
              <TableRow className={classes.row} key={row.id}>
                <CustomTableCell>{row.userDetail && row.userDetail.firstName} {row.userDetail && row.userDetail.lastName}</CustomTableCell>
                <CustomTableCell component="th" scope="row">
                  {row.content}
                </CustomTableCell>
                <CustomTableCell className={classes.pointer} onClick={() => openView(row.id)}>View</CustomTableCell>
                <CustomTableCell className={classes.pointer} onClick={() => updatePost(row.id)}>Edit</CustomTableCell>
                <CustomTableCell className={classes.pointer}><Delete onClick={() => removePost(row.id)}/></CustomTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'Previous Page',
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page',
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </React.Fragment>
  );
}

RoomerPostList.propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.array,
  updatePost: PropTypes.func,
  openView: PropTypes.func
};

RoomerPostList.defaultProps = {
  list: []
};

export default withStyles(styles)(RoomerPostList);